import { useController } from 'react-hook-form'
import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'
import itLocale from 'i18n-iso-countries/langs/it.json'

import { SelectField } from '@components/molecules/SelectField'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('components.country_select')

countries.registerLocale(enLocale)
countries.registerLocale(itLocale)

type CountrySelectProps = {
  name: string
  label: string
  control: any
  defaultValue?: string
  hideLabel?: boolean
}

export function CountrySelect({ name, control, defaultValue, ...props }: CountrySelectProps) {
  const {
    field: { value, onChange },
    formState: { errors },
  } = useController({
    defaultValue,
    name,
    control,
  })

  const fullLocale = navigator.languages ? navigator.languages[0] : navigator.language
  const locale = fullLocale.split('-')[0]
  let countryObj = countries.getNames(locale, { select: 'official' })
  if (Object.keys(countryObj).length === 0) {
    countryObj = countries.getNames('en', { select: 'official' })
  }
  const countryList = Object.entries(countryObj).map(([key, value]) => ({
    value: key,
    label: value,
  }))

  return (
    <SelectField
      search
      name={name}
      placeholder={t('placeholder')}
      options={countryList}
      value={value}
      onValueChange={onChange}
      errors={errors}
      {...props}
    />
  )
}
